import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { withUser } from '../../modules/User';
import { withUpdatePageName } from '../../modules/Menu';

function ProtectedRoute({
  component: Component,
  location,
  isLogged,
  name,
  updatePageName,
  ...rest
}) {
  useEffect(() => updatePageName(name), [name, updatePageName]);
  return (
    <Route
      {...rest}
      render={props => isLogged
        ? <Component {...props} />
        : (
          <Redirect
            to={{
              pathname: "/signIn",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

ProtectedRoute.defaultProps = {
  location: { pathName: '' },
};

ProtectedRoute.propTypes = {
  component: PropTypes.any.isRequired,
  location: PropTypes.shape({
    pathName: PropTypes.string
  }),
};

export default withUpdatePageName(withUser(ProtectedRoute));
